<template>
  <div>
    <!-- <router-view v-if="this.getLoggedInUser() != null" :name="selectedRouteName"></router-view> -->
    <div
      class="login-main-div"
      :style="{
        background: 'no-repeat',
        'background-image': loginBackgroundImage?`url(${loginBackgroundImage})`: `url(${backgroundUrl})`,
        'background-size': 'cover',
        'background-position': 'center',
      }"
    >
      <div class="row login-div" style="margin: 0px;">
        <div class="col-md-4 p-0">
          <div class="row fields-div">
            <div class="row style-login-bar">
              <div class="col-md-12 heading-div">
                <h3 class="heading pt-2">
                  <img :src="logoWithText" v-show="isBrandingLogoVisible" alt="FUSION"  style="position: relative;top: 7px;">
                </h3>
                  <span v-if="brandName && isActiveClientBranding" style="color:#aaa">{{brandName}}</span>
              </div>
              <div class="col-md-12 input-filed-div">
                <div class="col-md-12 input-div form-group p-0">
                  <label class="login-label">{{$t('Username')}}</label>
                  <input
                    type="text"
                    class="form-control input-sm username-login"
                    v-model="userInfo.username"
                    :placeholder="$t('Username')"
                    name="username"
                    autofocus="true"
                    autocomplete="off"
                    @keyup.enter="logIn(userInfo)"
                  />
                </div>
                <div
                  class="col-md-12 input-div form-group old-passowrd-div p-0"
                  style="margin-bottom: 16px"
                >
                  <label class="login-label">{{$t('Password')}}</label>
                  <div class="w-100" style="position: relative; display: flex;">
                   <input
                    id = "password_field"
                    :type="passwordFieldType"
                    class="form-control input-sm password-login"
                    v-model="userInfo.password"
                    :placeholder="$t('Password')"
                    autocomplete="off"
                    style="position: relative;"
                    @keyup.enter="logIn(userInfo)"
                    />
                    <!-- v-model="userInfo.password" -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" @click="switchVisibility" style="position: absolute;inset-inline-end :1%; bottom: 8px;" type="password" fill="#6d6d6d" class="bi bi-eye-fill" viewBox="0 0 16 16">
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                    </svg>
                  </div>
                </div>
                <div v-if="isGlobalRememberPasswordEnabled" class="col-md-12 input-div form-group p-0" style="margin-bottom:0px !important">
                  <input
                      type="checkbox"
                      class="remember-password"
                      id="rememberPassword"
                      ref="rememberPasswordEnable"
                      @click="isRememberPasswordEnabled=!isRememberPasswordEnabled"
                      :checked="isRememberPasswordEnabled?true:false"
                  />
                  <!-- @click="enableRememberPassword(event)" -->
                  <label class="remember-password" for="rememberPassword" style="padding:0px 9px;color:#757575">{{$t('Remember Password')}}</label>
                </div>
              </div>
              <div class="col-md-12 login-wrapper">
                <div class="col-md-12">
                  <button
                    class="col-md-6 btn btn-sm p-2 btn info"
                    @click="logIn(userInfo)"
                    id="login_btn"
                  >
                    {{$t('Login')}}
                  </button>
                  <!-- <img id="logo" src="images/workflowlabsLogo.png"> -->
                </div>
              </div>
              <!-- <div class="col-md-12 powered-by-logo" v-if="isActiveClientBranding">
                <div class="powered" style="font-size:9px">Powered by </div>
                <div class="powered-logo">
                  <img :src="fusionLogo"/>  
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div style="position: absolute;bottom: 0px;inset-inline-end :5px;background: #00000078;padding: 6px 10px;">
        <a class="link" href="#" @click.prevent="changeModalComponent('terms')">{{$t('Terms of Service')}}</a><span style="color: grey;"> | </span><a class="link" href="#" @click.prevent="changeModalComponent('policy')">{{$t('Privacy Policy')}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import backgroundUrl from "../../assets/DAM2.jpg";
import Utils from "../../components.utils.js";
import { encryptPassword, decryptPassword } from '../../components.crypto.js';
import iframePluginsMixin from '../../mixins/iframePluginsMixin.js';

export default {
  mixins:[iframePluginsMixin],
  data() {
    return {
      userInfo: {},
      backgroundUrl,
      passwordFieldType:"password",
      logoWithText:Utils.getLogoWithText(),
      fusionLogo:Utils.getLogoWithText(),
      loginBackgroundImage:null,
      isActiveClientBranding:false,
      brandName:null,
      isBrandingLogoVisible:false,
      isRememberPasswordEnabled:false,
      isGlobalRememberPasswordEnabled:false,
    };
  },
  // computed: {
  //   toHomePage() {
  //     return this.getLoggedInUser() != null && this.isFilePreviewRedirectUrl() == false;
  //   },
  //   selectedRouteName(){
  //     if (this.getLoggedInUser() != null && this.isFilePreviewRedirectUrl() == false){
  //       return 'explorer'
  //     }else if (this.isFilePreviewRedirectUrl()){
  //       return "preview"
  //     }
  //     return ''
  //   }
  // },
  // watch:{
  //   toHomePage(newVal){
  //     if (newVal){
  //       this.loadMainWindow()
  //     }
  //   }
  // },
  methods: {
    isFilePreviewRedirectUrl(){
       let url = decodeURIComponent(window.location.href);
      let pattern = /((\/assets)\/([a-zA-Z0-9]+)\/(view))/;
      if(pattern.test(String(url))){
         return true;
      }
      return false;
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },

    

    logIn(info) {
      const {encrypted} = encryptPassword(this.userInfo.password, this.userInfo.username);

      const infoUser = {
        username: this.userInfo.username,
        password: encrypted,
      };

      this.logInToServer(info).then((data) => {
        if (!Utils.isAcceptedStatusCode(data.statusCode)) {
          this.$toast.error(data.message);
          return
        }
        this.passwordFieldType = "password"
        delete this.userInfo["password"]
        try{
          document.getElementById("password_field").focus();
        }catch(e){console.log(e)}

        try{
          if(this.isRememberPasswordEnabled) {
            localStorage.setItem("remember_log",JSON.stringify(infoUser));
          } else {
            localStorage.removeItem("remember_log")
          }
        }catch(e){console.log(e)}
        
        this.initializeLanguage();
        
        if((window.self !== window.top) && window.name && (window.name !='browse' || window.name && window.name !='fusion-browse')){
            console.log("inside iframe");
            console.log("Plugin name ...............",window.name);
            this.loadPluginsWithinIframe();
            return;
        }
        try{
          let resolvePath = this.$route.fullPath || window.location.pathname;
          let resolvedPathObj = this.$router.resolve({path:resolvePath});
          if(resolvedPathObj.resolved && resolvedPathObj.resolved.query && resolvedPathObj.resolved.query.continue){
            let newPath = resolvedPathObj.resolved.query.continue || '';
            let newresObj = this.$router.resolve({path:newPath});
            if(String(newresObj.resolved.name).indexOf('blaze_fusion_') > -1){
                  this.$parent.selectedRouteName = 'blaze_fusion_browse';
                  this.$router.replace({name:'blaze_fusion_browse'}); //replace will not hold in history
                  return;
              }
              if(String(newresObj.resolved.name).indexOf('NRAA_upload_metadata') > -1){
                  this.$parent.selectedRouteName = 'NRAA_upload_metadata';
                  this.$router.replace({name:'NRAA_upload_metadata'}); //replace will not hold in history
                  return;
              }
          }
          console.log(`resolvedPathObj`,resolvedPathObj);
        }catch(e){
          console.log('e:',e)
        } 
        
        // this.getUserPreferedLanguage();
        //  this.isFilePreviewRedirectUrl();
        if(this.isFilePreviewRedirectUrl()){
          let path = this.$route.query.redirectUrl;
          if(this.$parent && this.$parent.selectedRouteName){
              this.$parent.selectedRouteName = 'preview';
              this.$router.push({path:path});
          }
        }
        else{
          if(this.$parent && this.$parent.selectedRouteName){
              let path = this.$route.query.continue || '/explorer';
              this.$parent.selectedRouteName = 'explorer';
              let query = {name:'explorer'};
              if(this.getPathLocationInfoToLoad){
                let resolveObj = this.$router.resolve({path:this.getPathLocationInfoToLoad});
                if(resolveObj && resolveObj.route && resolveObj.route.name){
                    this.setLoadPageInfo(resolveObj.route);
                }
              }else{
                let resolveObj = this.$router.resolve({path:path});
                if(resolveObj && resolveObj.route && resolveObj.route.name){
                    this.setLoadPageInfo(resolveObj.route);
                }
              }
              this.$router.push(query);
          }
        }
      });
    },
    changeModalComponent(compName){
        this.$router.push({
          name:compName,
          params:{
            parentinfo: this.$route
          }
        })
    },
    /*getUserPreferedLanguage(){
      this.fetchUserPrefferedLanguage().then((data)=>{
        if(!data || !('mapper' in data)){
          return;
        }
        this.languageMapper = data.mapper;
        this.languageOrientation = data.orientation;
        this.$set(this.$i18n, "locale", data.code)
        this.$set(this.$i18n, "locale_name", data.name)
        this.$set(this.$i18n, "orientation", data.orientation)
        this.$i18n.setLocaleMessage(data.code, this.languageMapper);
        });
    },*/


    // loadMainWindow(){
    //   if (this.toHomePage){
    //     this.$router.push({ name: 'explorer'});
    //   }else if (this.isFilePreviewRedirectUrl()){
    //     this.$router.push({ name: 'preview'});
    //   }
    // },
    ...mapActions("users", ["logInToServer", "loadUserInfoFromCookies"]),
    ...mapActions("language", ["fetchUserPrefferedLanguage"]),
    // ...mapGetters("users", ["getLoggedInUser"]),
    // ...mapGetters("locations", ["getLocationinfoToLoad"]),
    ...mapMutations("locations", ["setLoadPageInfo"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("beforeAuth",["getFusionDataWithoutAuth"]),
  },
  computed:{
      getUserPreferedLanguageDetails:{
        get(){
            return this.$store.state.language.languageUserPrefered;
        }
    },
    ...mapGetters("locations",["getPathLocationInfoToLoad"]),
  },  
  created() {
    this.getFusionDataWithoutAuth().then((data)=>{
        this.isBrandingLogoVisible = true;
        if(data && Object.prototype.hasOwnProperty.call(data,'client_logo') &&  data.client_logo){
            Utils.setLocalStorageValue('client_logo', JSON.stringify(data.client_logo))
        }else{
          localStorage.removeItem("client_logo");
        }
          
        if(Utils.getLocalStorageValue('client_logo')){
            this.logoWithText = Utils.convertToLoginIPDomainName(JSON.parse(Utils.getLocalStorageValue('client_logo')));
            this.isActiveClientBranding = true;
        }else{
            if(this.logoWithText){
                this.logoWithText = Utils.convertToLoginIPDomainName(Utils.getLogoWithText());
                this.isActiveClientBranding = false;
            }
        }

        if(data && Object.prototype.hasOwnProperty.call(data,'login_page_background_image_web') &&  data.login_page_background_image_web){
            Utils.setLocalStorageValue('login_page_background_image_web', JSON.stringify(data.login_page_background_image_web))
        }else{
          localStorage.removeItem("login_page_background_image_web");
        }

        if(Utils.getLocalStorageValue('login_page_background_image_web')){
            this.loginBackgroundImage = Utils.convertToLoginIPDomainName(JSON.parse(Utils.getLocalStorageValue('login_page_background_image_web')));
        }else{
            // if(this.logoWithText){
            //     this.loginBackgroundImage = Utils.convertToLoginIPDomainName(Utils.getLogoWithText());
            // }
            this.loginBackgroundImage = this.backgroundUrl;
        }


        if(data && Object.prototype.hasOwnProperty.call(data,'enable_remember_password') &&  data.enable_remember_password){
            this.isGlobalRememberPasswordEnabled = true;
        }
        if (this.isGlobalRememberPasswordEnabled){
            const rememberedUser = JSON.parse(localStorage.getItem('remember_log'));
            
            if (rememberedUser) {
                this.userInfo.username = rememberedUser.username;
                this.userInfo["password"] = decryptPassword(rememberedUser.password);
                this.isRememberPasswordEnabled = true;
            }else{
                this.isRememberPasswordEnabled = false;
                this.userInfo = {};
            }
        }
        else{
            localStorage.removeItem("remember_log")
        }
    }).catch((e)=>{
       console.log(e);
      this.isBrandingLogoVisible = true;
    });
    if(Utils.getLocalStorageValue('client_branding_name')){
        this.brandName = JSON.parse(Utils.getLocalStorageValue('client_branding_name'))
     }


    // this.loadUserInfoFromCookies();
/*     this.loadMainWindow()
    this.isFilePreviewRedirectUrl(); */
 /*    try{
       this.$parent.$refs.externalPluginWrapperRef.innerHTML = '';
    }catch(e){console.log(e)} */
     //remove already stored plugins
    //  document.querySelectorAll('.common_plugin_bundle_css').forEach(e => {
    //       e.remove();
    //  });
    //  document.querySelectorAll('.common_plugin_bundle_js').forEach(e => {e.remove()})
    //  window.pluginsComponent = {};
  },
};
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #bbb;
$table-row-border: none;
$active-blue: #007bff;
$primary-background: #1a1e21;

.login-main-div {
  background-color: #474646;
  height: 100vh;
  margin: 0px;
  background-repeat: no-round;
}

.login-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.login-label {
  color: #ccc;
  padding-inline-end: 10px;
  display: none;
}

.input-div {
  display: inline-flex;
}

#login_btn {
  background-color: #0a729f;
  border-color: #2a729f;
  color: #eee;
}


#login_icon {
  width: 100px;
  position: relative;
  bottom: 30px;
  inset-inline-start:36%;
}

.fields-div {
  /*background: rgba(0, 0, 0, 0.1);*/
  border-radius: 20px;
  margin-inline-start: 15px !important;
}

.input-group-addon {
  i {
    position: relative;
    inset-inline-end: 5px;
    color: #d6dfee;
  }
}

.input-group-addon {
  border-radius: 4px 0px 0px 4px !important;
  color: #1c1c1c;
  background-color: #3c5171;
  border: 1px solid #888;
  border-inline-end: 0px;
}

.username-login,
.password-login {
  border-radius: 4px;
  background-color: #00000061;
  border: 1px solid #525252;
  color: #fff;
}

.heading-div {
  background: #000000c4;
  border-radius: 10px 10px 0px 0px;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.input-filed-div {
  // padding: 25px;
  padding: 25px 25px 10px 25px;
  background-color: #000000c4;
}

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    // margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}

.remember-password:focus{
  box-shadow:none !important;
}

#rememberPassword{
  width:20px;
  height:20px;
}


.login-wrapper {
  background: #000000c4;
  padding: 10px;
  border-radius: 0px 0px 10px 10px;
  height: 85px;
  position: relative;
}

#logo {
  position: relative;
  top: 39px;
  width: 159px;
  inset-inline-end: 79px;
  filter: brightness(2);
}

.heading {
  height: 70px;
    width: 200px;
    position: relative;
    align-items: flex-end;
    display: inline-flex;
    justify-content: center;
  img{
    max-width: 100%;
    max-height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
  }
}

.domain-div {
  label {
    color: #bfbbbb !important;
  }
}

.domain-div {
  span {
    color: #bfbbbb !important;
  }
}

.style-login-bar {
  border: 1px solid #3d3c3c;
  box-shadow: 0px 0px 3px 0px #626262;
  border-radius: 10px;
}

.powered-by-logo{
  display: flex;
  background: #000000c4;
  align-items: center;
  color: #575757;
  justify-content: center;
  .powered{
    margin-inline-end: 4px;
    margin-top: po;
    position: relative;
    top: 2px;
  }
}
.powered-by-logo img{
  filter: brightness(0.5);
  width: 85px;
}
.link,
.link:hover {
    color: #1d9bd1;
}
</style>